var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 61,
    viewBox: "0 0 85 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5293 9.24993H75.0391V7.80908C75.0391 3.68974 71.6877 0.338379 67.5684 0.338379H7.4707C3.35136 0.338379 0 3.68974 0 7.80908V43.2297C0 47.349 3.35136 50.7004 7.4707 50.7004H9.96094V53.1906C9.96094 57.31 13.3123 60.6613 17.4316 60.6613H77.5293C81.6486 60.6613 85 57.31 85 53.1906V16.7206C85 12.6013 81.6486 9.24993 77.5293 9.24993ZM4.98047 43.2298V7.80908C4.98047 6.43597 6.09759 5.31885 7.4707 5.31885H67.5684C68.9415 5.31885 70.0586 6.43597 70.0586 7.80908V43.2297C70.0586 44.6028 68.9415 45.7199 67.5684 45.7199H7.4707C6.09759 45.7201 4.98047 44.603 4.98047 43.2298ZM80.0195 53.1908C80.0195 54.5639 78.9024 55.681 77.5293 55.681H17.4316C16.0585 55.681 14.9414 54.5639 14.9414 53.1908V50.7005H67.5684C71.6877 50.7005 75.0391 47.3492 75.0391 43.2298V14.2304H77.5293C78.9024 14.2304 80.0195 15.3475 80.0195 16.7206V53.1908Z",
    fill: "#B82428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 20.7466H27.2963V25.7271H9.96094V20.7466Z",
    fill: "#B82428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 10.7856H22.1028V15.7661H9.96094V10.7856Z",
    fill: "#B82428"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0977 35.759H65.0781V40.7395H60.0977V35.759Z",
    fill: "#B82428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCard);
export default __webpack_public_path__ + "static/media/businessCard.f8fe0f7b6812fca9c82f6d1c393bc532.svg";
export { ForwardRef as ReactComponent };